import { useTranslation } from '@/lib/i18n';
import { PageShell } from '@/components/ui';
import { HomeBannerCreateButton, HomeBannerListPanel } from '../components/HomeBannerListPanel';

export const HomeBannerListPage = () => {
  const { t } = useTranslation('common');
  return (
    <PageShell
      title={t('cms.banners.title')}
      actions={<HomeBannerCreateButton />}
      data-testid="home-banner-list-page"
    >
      <HomeBannerListPanel />
    </PageShell>
  );
};
